var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1667 2.49998H16.5C16.721 2.49998 16.933 2.58778 17.0893 2.74406C17.2456 2.90034 17.3334 3.1123 17.3334 3.33331V16.6666C17.3334 16.8877 17.2456 17.0996 17.0893 17.2559C16.933 17.4122 16.721 17.5 16.5 17.5H1.50002C1.27901 17.5 1.06704 17.4122 0.910765 17.2559C0.754484 17.0996 0.666687 16.8877 0.666687 16.6666V3.33331C0.666687 3.1123 0.754484 2.90034 0.910765 2.74406C1.06704 2.58778 1.27901 2.49998 1.50002 2.49998H4.83335V0.833313H6.50002V2.49998H11.5V0.833313H13.1667V2.49998ZM2.33335 7.49998V15.8333H15.6667V7.49998H2.33335ZM4.00002 9.16665H5.66669V10.8333H4.00002V9.16665ZM4.00002 12.5H5.66669V14.1666H4.00002V12.5ZM7.33335 9.16665H14V10.8333H7.33335V9.16665ZM7.33335 12.5H11.5V14.1666H7.33335V12.5Z",
    fill: "#273043",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShift);
export default __webpack_public_path__ + "static/media/shift.3274de48f9acaf1aa645631a05b8c06b.svg";
export { ForwardRef as ReactComponent };